import BillOfMaterial from '@/models/BillOfMaterial/BillOfMaterial';

export default class BillOfMaterialFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partNumberId  = '';
		this.partNumberPartNumber = '';
		this.partName = '';
		this.customer = '';
		this.partClassification = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partNumberId : '0',
			partNumberPartNumber : '0',
			partName : '0',
			customer : '0',
			partClassification : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}